const l = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fill-rule="evenodd"
        d="M1 1h10v10H1V1Zm12 0h10v10H13V1Zm-2 12H1v10h10V13Zm2 0h10v10H13V13Z" clip-rule="evenodd"></path>
</svg>`;
export {
  l as default
};
